<template>
   <div class="sidebar-fixed position-fixed">
   <template v-if="ai===1 && lang==='RU'">
     <list-group class="mt-3">
      <list-group-item :action="true" @click.native="activeFolder0 = -1, activeFolderUid0 = '00000000-0000-0000-0000-000000000000',$emit('folder0','00000000-0000-0000-0000-000000000000'), $emit('folder2','00000000-0000-0000-0000-000000000000'),$emit('folder1','00000000-0000-0000-0000-000000000000')" :active="activeFolder0 === -1">ПОИСК</list-group-item>
    </list-group>
    <list-group class="light-blue-color" v-for="(folder0, index0) in folderList0" :key="index0">
      <list-group-item :action="true" @click.native="cngfolder0(folder0, index0)" :active="activeFolder0 === index0">{{folder0.Description}}</list-group-item>
        <list-group class="list-group-flush" v-if="folder0.Ref_Key === activeFolderUid0" v-for="(folder1, index1) in folderList1" :key="index1">
          <list-group-item class="btn btn-sm color-white black-text" :action="true" @click.native="cngfolder1(folder1, index1)" :active="activeFolder1 === index1">{{folder1.Description}}</list-group-item>
            <list-group class="list-group-flush" v-if="folder1.Ref_Key === activeFolderUid1" v-for="(folder2, index2) in folderList2" :key="index2">
              <list-group-item class="btn btn-sm2 color-white " :action="true" @click.native="activeFolder2 = index2, activeFolderUid2 = folder2.Ref_Key, $emit('folder2',folder2.Ref_Key),$emit('folder1',folder2.Parent_Key)" :active="activeFolder2 === index2">{{folder2.Description}}</list-group-item>
            </list-group>
          </list-group>
      </list-group>
   </template>
    <template v-if="ai===1 && lang==='EN'">
     <list-group class="mt-3">
      <list-group-item :action="true" @click.native="activeFolder0 = -1, activeFolderUid0 = '00000000-0000-0000-0000-000000000000',
      $emit('folder0','00000000-0000-0000-0000-000000000000'),$emit('folder2','00000000-0000-0000-0000-000000000000'),$emit('folder1','00000000-0000-0000-0000-000000000000')" :active="activeFolder0 === -1">SEARCH</list-group-item>
    </list-group>
    <list-group class="light-blue-color" v-for="(folder0, index0) in folderList0" :key="index0">
      <list-group-item :action="true" @click.native="cngfolder0(folder0, index0)" :active="activeFolder0 === index0">{{folder0.Description}}</list-group-item>
        <list-group class="list-group-flush" v-if="folder0.Ref_Key === activeFolderUid0" v-for="(folder1, index1) in folderList1" :key="index1">
          <list-group-item class="btn btn-sm color-white black-text" :action="true" @click.native="cngfolder1(folder1, index1)" :active="activeFolder1 === index1">{{folder1.Description}}</list-group-item>
            <list-group class="list-group-flush" v-if="folder1.Ref_Key === activeFolderUid1" v-for="(folder2, index2) in folderList2" :key="index2">
              <list-group-item class="btn btn-sm2 color-white " :action="true" @click.native="activeFolder2 = index2, activeFolderUid2 = folder2.Ref_Key, $emit('folder2',folder2.Ref_Key),$emit('folder1',folder2.Parent_Key)" :active="activeFolder2 === index2">{{folder2.Description}}</list-group-item>
            </list-group>
          </list-group>
      </list-group>
   </template>
    <template v-if="ai===1 && lang==='GE'">
     <list-group class="mt-3">
      <list-group-item :action="true" @click.native="activeFolder0 = -1, activeFolderUid0 = '00000000-0000-0000-0000-000000000000',
      $emit('folder0','00000000-0000-0000-0000-000000000000'),$emit('folder2','00000000-0000-0000-0000-000000000000'),$emit('folder1','00000000-0000-0000-0000-000000000000')" :active="activeFolder0 === -1">ძიება</list-group-item>
    </list-group>
    <list-group class="light-blue-color" v-for="(folder0, index0) in folderList0" :key="index0">
      <list-group-item :action="true" @click.native="cngfolder0(folder0, index0)" :active="activeFolder0 === index0">{{folder0.Description}}</list-group-item>
        <list-group class="list-group-flush" v-if="folder0.Ref_Key === activeFolderUid0" v-for="(folder1, index1) in folderList1" :key="index1">
          <list-group-item class="btn btn-sm color-white black-text" :action="true" @click.native="cngfolder1(folder1, index1)" :active="activeFolder1 === index1">{{folder1.Description}}</list-group-item>
            <list-group class="list-group-flush" v-if="folder1.Ref_Key === activeFolderUid1" v-for="(folder2, index2) in folderList2" :key="index2">
              <list-group-item class="btn btn-sm2 color-white " :action="true" @click.native="activeFolder2 = index2, activeFolderUid2 = folder2.Ref_Key, $emit('folder2',folder2.Ref_Key),$emit('folder1',folder2.Parent_Key)" :active="activeFolder2 === index2">{{folder2.Description}}</list-group-item>
            </list-group>
          </list-group>
      </list-group>
   </template>
 </div>
</template>

<script>
import {
  Btn,
  mdbBtn,
  mdbBtnGroup,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
  Container,
  NumericInput,
  Row,
  Column,
  Tbl,
  TblHead,
  TblBody
} from 'mdbvue'
import format from 'date-fns/format'
import subDays from 'date-fns/sub_days'
// import addDays from 'date-fns/add_days'
export default {
  name: 'sidebar',
  components: {
    Btn,
    mdbBtn,
    mdbBtnGroup,
    ListGroup,
    ListGroupItem,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Container,
    NumericInput,
    Row,
    Column,
    Tbl,
    TblHead,
    TblBody
  },
  props: ['authorized', 'mng', 'ai', 'folders', 'lang', 'selectedManager', 'activeMng', 'contragents', 'deliverySchemes'],
  computed: {
    folderList0 () {
      return this.folders.filter(folder => {
        if (folder.Parent_Key === '00000000-0000-0000-0000-000000000000') return true
        else return false
      })
    },
    folderList1 () {
      return this.folders.filter(folder => {
        if (folder.Parent_Key === this.activeFolderUid0) return true
        else return false
      })
    },
    folderList2 () {
      return this.folders.filter(folder => {
        if (folder.Parent_Key === this.activeFolderUid1) return true
        else return false
      })
    }
  },
  updated () {
    // console.log('selected manager ' + this.selectedManager)
    // this.$event.target.value = this.selectedMng
    // if (this.selectedMng === '00000000-0000-0000-0000-000000000000') this.selectedMng = '00000000-0000-0000-0000-000000000000'
    // this.selectedMng = this.selectedManager
  },
  mounted () {
    // console.log('selected manager ' + this.selectedManager + ' this.selectedMng ' + this.selectedMng)
  },
  data () {
    return {
      openbox: true,
      timer: false,
      bbIndex: 0,
      selectedclass: '',
      activeFolder0: -1,
      activeFolder1: -1,
      activeFolder2: -1,
      activeFolderUid0: '00000000-0000-0000-0000-000000000000',
      activeFolderUid1: null,
      activeFolderUid2: null,
      dateFormat: 'DD/M',
      dateOne: subDays(Date(), 7),
      dateTwo: Date()
    }
  },
  methods: {
    selectScheme (event) {
      console.log(event.target.value)
      this.$emit('selectScheme', event.target.value)
    },
    changeOrdered () {
      this.$emit('changeordered')
    },
    apply () {
      console.log(this.dateOne + ' ' + this.dateTwo)
      this.$emit('DateSelected', {dateone: this.dateOne, datetwo: this.dateTwo})
    },
    start () {
      this.bbIndex++
      if (this.bbIndex === 10) this.bbIndex = 0
      this.timer = true
    },
    formatDates (dateOne, dateTwo) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat)
      }
      if (dateTwo) {
        formattedDates += ' - ' + format(dateTwo, this.dateFormat)
      }
      return formattedDates
    },
    cngfolder0 (folder0, index0) {
      this.activeFolder0 = index0
      this.$emit('folder0', folder0.Ref_Key)
      this.activeFolder1 = -1
      this.activeFolder2 = -1
      if (this.activeFolderUid0 === folder0.Ref_Key) {
        this.activeFolderUid0 = '00000000-0000-0000-0000-000000000000'
        this.activeFolderUid1 = '00000000-0000-0000-0000-000000000000'
        this.activeFolderUid2 = '00000000-0000-0000-0000-000000000000'
        this.$emit('folder2', '00000000-0000-0000-0000-000000000000')
        this.$emit('folder1', '00000000-0000-0000-0000-000000000000')
      } else {
        this.activeFolderUid0 = folder0.Ref_Key
        this.activeFolderUid1 = '00000000-0000-0000-0000-000000000000'
        this.activeFolderUid2 = '00000000-0000-0000-0000-000000000000'
        this.$emit('folder2', '00000000-0000-0000-0000-000000000000')
        this.$emit('folder1', '00000000-0000-0000-0000-000000000000')
      }
    },
    cngfolder1 (folder1, index1) {
      this.activeFolder1 = index1
      this.activeFolder2 = -1
      if (this.activeFolderUid1 === folder1.Ref_Key) {
        this.activeFolderUid1 = '00000000-0000-0000-0000-000000000000'
        this.activeFolderUid2 = '00000000-0000-0000-0000-000000000000'
        this.$emit('folder2', '00000000-0000-0000-0000-000000000000')
        this.$emit('folder1', '00000000-0000-0000-0000-000000000000')
      } else {
        this.activeFolderUid1 = folder1.Ref_Key
        this.activeFolderUid2 = '00000000-0000-0000-0000-000000000000'
        this.$emit('folder1', folder1.Ref_Key)
        this.$emit('folder2', '00000000-0000-0000-0000-000000000000')
      }
    }
  },
  watch: {
    selectedclass () {
      this.$bus.$emit('selectedclass', this.selectedclass)
    }
  },
  timers: {
    start: { time: 20000, autostart: true, repeat: true }
  }
}

</script>
<style scoped>
 .btn:not(:disabled):not(.disabled) {
    cursor: default;
}
.btn.btn-sm2 {
    padding: 0.1rem 0.4rem;
    font-size: 0.6rem;
    margin-left: 1rem;
    color: #212529;
}
.list-group-item {
    position: relative;
    display: block;
    padding: 0.75rem 1.25rem;
    margin-bottom: -1px;
    border: 0px;
    cursor: pointer;
    border-left: 5px solid rgba(0, 0, 0, 0.125);
  }
.list-group-item.active {
    z-index: 2;
    color: #212529;
    background-color: #e9ecef;
    border-color: #007bff;
    border-left: 5px solid #007bff;
    box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.18);
}
.list-group .list-group-item:last-child {
    margin-bottom: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue